import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BaseService } from "./base.sevice";
import { PaginatedSearch } from "../models/PaginatedSearch";
import { Observable } from "rxjs";

@Injectable()
export class TransactionService extends BaseService {

    url = `${environment.apiBaseUrl}/managers/transactions`;

    constructor(private http: HttpClient) {
        super();
    }

    get(id: string) {
        return this.http.get(`${this.url}/${id}`);
    }

    lookup(refunded?: boolean, criteria?: PaginatedSearch) {
        let httpParams = this.toHttpParams(criteria);

        if (refunded != undefined)
            httpParams = httpParams.append('refunded', refunded);

        return this.http.get(this.url, { params: httpParams });
    }

    export(refunded?: boolean, criteria?: PaginatedSearch): Observable<Blob> {
        let httpParams = this.toHttpParams(criteria).append('offset', new Date().getTimezoneOffset());

        if (refunded != undefined)
            httpParams = httpParams.append('refunded', refunded);

        return this.http.get<Blob>(`${this.url}/export`, { params: httpParams, responseType: 'blob' as 'json' });
    }
}